import { createContext, useState, type ReactNode } from 'react';

export interface HeaderFooterBasicStateContextType {
  headerBasicState: boolean;
  footerBasicState: boolean;
  setHeaderBasicState: (value: boolean) => void;
  setFooterBasicState: (value: boolean) => void;
}

export const HeaderFooterBasicStateContext = createContext<
  HeaderFooterBasicStateContextType | undefined
>(undefined);

export const HeaderFooterBasicStateProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [headerBasicState, setHeaderBasicState] = useState<boolean>(false);
  const [footerBasicState, setFooterBasicState] = useState<boolean>(false);

  return (
    <HeaderFooterBasicStateContext.Provider
      value={{
        headerBasicState,
        footerBasicState,
        setHeaderBasicState,
        setFooterBasicState,
      }}
    >
      {children}
    </HeaderFooterBasicStateContext.Provider>
  );
};

export const MockHeaderFooterBasicStateProvider = ({
  children,
  mockHeaderBasicState = false,
  mockFooterBasicState = false,
  mockSetHeaderBasicState = () => {},
  mockSetFooterBasicState = () => {},
}: {
  children: ReactNode;
  mockHeaderBasicState?: boolean;
  mockFooterBasicState?: boolean;
  mockSetHeaderBasicState?: (value: boolean) => void;
  mockSetFooterBasicState?: (value: boolean) => void;
}) => (
  <HeaderFooterBasicStateContext.Provider
    value={{
      headerBasicState: mockHeaderBasicState,
      footerBasicState: mockFooterBasicState,
      setHeaderBasicState: mockSetHeaderBasicState,
      setFooterBasicState: mockSetFooterBasicState,
    }}
  >
    {children}
  </HeaderFooterBasicStateContext.Provider>
);
